__turbopack_context__.v({
  "emptyButton": "product-panel-module-scss-module__zGRIeW__emptyButton",
  "productPanel": "product-panel-module-scss-module__zGRIeW__productPanel",
  "section": "product-panel-module-scss-module__zGRIeW__section",
  "section__bigMargin": "product-panel-module-scss-module__zGRIeW__section__bigMargin",
  "section__bottom_margin": "product-panel-module-scss-module__zGRIeW__section__bottom_margin",
  "section__litleMargin": "product-panel-module-scss-module__zGRIeW__section__litleMargin",
  "section__withoutPadding": "product-panel-module-scss-module__zGRIeW__section__withoutPadding",
  "yaPay": "product-panel-module-scss-module__zGRIeW__yaPay",
  "yaPayButton": "product-panel-module-scss-module__zGRIeW__yaPayButton",
});
